import { AppPagePlaceholder } from "./AppPagePlaceholder";

export function MoviesPage() {
  return <AppPagePlaceholder name="Movies" />;
}
